// extracted by mini-css-extract-plugin
export var divider = "_f3-7";
export var itemsToggle = "_f3-8";
export var mergeModal = "_f3-1";
export var optionCard = "_f3-4";
export var radioGroup = "_f3-6";
export var radioOption = "_f3-0";
export var selected = "_f3-5";
export var shipmentOptions = "_f3-2";
export var tableOptions = "_f3-3";